import Style from './style.module.css';

export default function TabGroup({
  tabs = [],
  activeTab,
  onChange,
  className = '',
}) {
  return (
    <div className={`${Style.container} ${className}`} role="tablist">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key;

        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`${Style.button} ${isActive ? Style.active : ''}`}
            onClick={() => onChange(tab.key)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
